import { Box, Button, Link, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import SynapseLogo from "../assets/images/SynapseLogo.png";

const VARIANT_STYLES = {
  noAccess: {
    Icon: LockOutlinedIcon,
    backgroundColor: "#FF73161A",
    borderColor: "#f97316",
    iconColor: "#f97316",
  },
  error: {
    Icon: WarningAmberOutlinedIcon,
    backgroundColor: "#dc26261A",
    borderColor: "#dc2626",
    iconColor: "#dc2626",
  },
};

function SynapseStatusPage({
  variant,
  heading,
  linkHref,
  linkText,
  linkSuffix,
  showRetryButton = false,
  onRetry,
}) {
  const { Icon, backgroundColor, borderColor, iconColor } =
    VARIANT_STYLES[variant];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f9fdff",
        px: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: 520,
          width: "100%",
          textAlign: "center",
          backgroundColor: "#FFFFFF",
          border: "1px solid #E6E6E6",
          borderRadius: "16px",
          px: { xs: 3, sm: 5 },
          py: { xs: 4, sm: 5 },
        }}
      >
        <Box
          component="img"
          src={SynapseLogo}
          alt="RepAssist"
          sx={{ height: 40, mb: 2 }}
        />

        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            backgroundColor,
            border: `1px solid ${borderColor}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2,
          }}
        >
          <Icon sx={{ fontSize: 28, color: iconColor }} />
        </Box>

        <Typography
          variant="h5"
          sx={{ fontWeight: 700, color: "#202020", mb: 1.5 }}
        >
          {heading}
        </Typography>

        <Typography sx={{ fontSize: "15px", color: "#666666" }}>
          Contact{" "}
          <Link
            href={linkHref}
            underline="hover"
            sx={{
              fontWeight: 600,
              color: "#396D87",
            }}
          >
            {linkText}
          </Link>{" "}
          {linkSuffix}
        </Typography>

        {showRetryButton && (
          <Button
            variant="contained"
            onClick={onRetry}
            sx={{
              mt: 3,
              textTransform: "none",
              fontWeight: 600,
              bgcolor: "#396D87",
              "&:hover": { bgcolor: "#2d5669" },
            }}
          >
            Try again
          </Button>
        )}
      </Box>
    </Box>
  );
}

export default SynapseStatusPage;
